export type WidgetType = 'consumer-status' | 'statistics' | 'saved-views'

export interface DashboardLayoutOptions {
  widgetOrder: WidgetType[]
  viewsPerRow: 1 | 2 | 3 | 4
}

const OPTIONS_STORAGE_KEY = 'docdot_dashboard_layout_options'

export const loadDashboardLayoutOptions = (): DashboardLayoutOptions => {
  try {
    const stored = localStorage.getItem(OPTIONS_STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored) as any

      const defaultOrder: WidgetType[] = ['consumer-status', 'statistics', 'saved-views']
      let widgetOrder: WidgetType[] = defaultOrder

      if (parsed.widgetOrder && Array.isArray(parsed.widgetOrder)) {
        const validOrder = parsed.widgetOrder.filter((id: string) => ['consumer-status', 'statistics', 'saved-views'].includes(id))
        if (validOrder.length === 3) {
          widgetOrder = validOrder as WidgetType[]
        }
      } else if (parsed.statisticsPosition) {
        if (parsed.statisticsPosition === 'after') {
          widgetOrder = ['consumer-status', 'saved-views', 'statistics']
        } else {
          widgetOrder = ['consumer-status', 'statistics', 'saved-views']
        }
      }

      return {
        widgetOrder,
        viewsPerRow: [1, 2, 3, 4].includes(parsed.viewsPerRow) ? parsed.viewsPerRow : 2,
      }
    }
  } catch (error) {
    console.error('Failed to load dashboard layout options:', error)
  }
  return {
    widgetOrder: ['consumer-status', 'statistics', 'saved-views'],
    viewsPerRow: 2,
  }
}

export const saveDashboardLayoutOptions = (options: DashboardLayoutOptions): void => {
  try {
    localStorage.setItem(OPTIONS_STORAGE_KEY, JSON.stringify(options))
  } catch (error) {
    console.error('Failed to save dashboard layout options:', error)
  }
}
